class AutoTranslator {
  constructor() {
    this.storageKey = 'user-locale'
    this.cacheStorageKey = 'auto-translate-cache-v4'
    this.maxCacheEntries = 1800
    this.cachePersistDelayMs = 120
    this.cachePersistTimer = null
    this.defaultLanguage = 'en'
    this.supportedLanguages = ['en', 'fr', 'es']
    this.currentLang = this.defaultLanguage

    try {
      this.currentLang = this.normalizeLang(localStorage.getItem(this.storageKey))
    } catch (error) {
      this.currentLang = this.defaultLanguage
    }

    this.currentPath = this.getWindowPath()
    this.excludedPathSubstrings = []

    this.baseProtectedTerms = ['PettyCash SAS', 'Petty Cash SAS', 'PettyCash', 'Petty Cash', 'PettyCa$h', 'Petty Ca$h', 'petty cash', 'petty ca$h', 'pettycash sas', 'pettycash', 'PETTY CASH', 'MTN Mobile Money', 'Orange Money', 'Business Suite', 'Business Account', 'MarketPlace', 'Njangi', 'XAF', 'FCFA']
    this.dynamicProtectedTerms = new Set()
    this.protectedTerms = new Set()
    this.protectedTermsHash = ''

    this.contextTranslations = {
      fr: {
        'welcome': 'Bienvenue',
        'welcome to': 'Bienvenue sur',
        'welcome 😃 to': 'Bienvenue 😃 sur',
        ', to pettycash: marketplace': ', sur PettyCash : MarketPlace',
        ', to pettycash: savings': ', sur PettyCash : Savings',
        ', to pettycash: fundraising': ', sur PettyCash : Fundraising',
        ', to pettycash: monitor': ', sur PettyCash : Monitor',
        ', to pettycash: njangi': ', sur PettyCash : Njangi',
        ', to pettycash business suite': ', sur PettyCash Business Suite',
        'to pettycash business suite': 'sur PettyCash Business Suite',
        'your credit score:': 'Votre score de credit :',
        'understanding your credit score': 'Comprendre votre score de credit',
        'shop at cheap prices/credit at our': 'Achetez a prix reduit ou a credit sur notre',
        'market place.': 'marketplace.',
        'we make your coins': 'Nous faisons fructifier vos petites economies',
        'become a fortune.': 'jusqu a devenir une fortune.',
        'we bring life into your': 'Nous donnons vie a vos',
        'dream projects.': 'projets de reve.',
        'we guide you to make great': 'Nous vous guidons pour prendre de meilleures',
        'financial decisions.': 'decisions financieres.',
        'join communities to': 'Rejoignez des communautes pour',
        'share resources together.': 'mutualiser vos ressources.',
        'explore petty ca$h marketplace': 'Decouvrez Petty Ca$h MarketPlace',
        'explore petty ca$h market place': 'Decouvrez Petty Ca$h MarketPlace',
        'explore petty ca$h savings': 'Decouvrez Petty Ca$h Savings',
        'explore petty ca$h fundraising': 'Decouvrez Petty Ca$h Fundraising',
        'explore petty ca$h monitor': 'Decouvrez Petty Ca$h Monitor',
        'explore petty ca$h njangi': 'Decouvrez Petty Ca$h Njangi',
        'explore petty ca$h business account': 'Decouvrez Petty Ca$h Business Account',
        'referred users': 'Utilisateurs parraines',
        'username': "Nom d'utilisateur",
        'signup date': "Date d'inscription",
        'payment status': 'Statut du paiement',
        'amount': 'Montant',
        'save': 'Épargner',
        'saved': 'Épargné',
        'savings': 'Épargne',
        'save now': 'Épargner maintenant',
        'save to buy': 'Épargner pour acheter',
        'save to buy this': 'Épargner pour acheter',
        'save to buy options': "Options d'achat avec épargne",
        'save to principal account': 'Épargner vers le compte principal',
        'amount saved': 'Montant épargné',
        'amount saved:': 'Montant épargné :',
        'your saved amount': 'Votre montant épargné',
        'total saved': 'Total épargné',
        'your total saved': 'Votre total épargné',
        'your saved amount:': 'Votre montant épargné :',
        'save amount': 'Montant à épargner',
        'amount to save': 'Montant à épargner',
        'amount to save (fcfa)': 'Montant à épargner (FCFA)',
        'amount to save (f cfa)': 'Montant à épargner (F CFA)',
        'input amount to save (f cfa)': 'Saisissez le montant à épargner (F CFA)',
        'enter amount to save': 'Saisissez le montant à épargner',
        'enter the amount you wish to save.': 'Saisissez le montant que vous souhaitez épargner.',
        'your amount to save is required': 'Votre montant à épargner est requis',
        "you've saved more than the product cost!": "Vous avez épargné plus que le coût du produit !",
        'already saved': 'Déjà épargné',
        'create savings campaign': "Créer une campagne d'épargne",
        'create, view and save objectively with discipline specific campaigns': 'Créez, consultez et épargnez objectivement avec des campagnes spécifiques à la discipline',
        'save into:': 'Épargner dans :',
        'save into you': 'Épargnez dans votre',
        'save into: new telephone': 'Épargner dans : nouveau téléphone',
        'save into loan': 'Épargner dans le prêt',
        'save into campaign': 'Épargner dans la campagne',
        'pettycash | save into campaign': 'PettyCash | Épargner dans une campagne',
        'saving here is by': 'Épargner ici se fait par',
        'home': 'Accueil',
        'savings': 'Épargne',
        'fundraising': 'Collecte de fonds',
        'njangi': 'Tontine',
        'monitor': 'Monitoring',
        'marketplace': 'MarketPlace',
        'market place': 'MarketPlace',
        'topup': 'Recharge',
        'business suite': 'Business Suite',
        'my savings': 'Mes épargnes',
        'my accounts': 'Mes comptes',
        'my account': 'Mon compte',
        'account': 'Compte',
        'accounts': 'Comptes',
        'balance': 'Solde',
        'my balance': 'Mon solde',
        'total balance': 'Solde total',
        'available balance': 'Solde disponible',
        'add funds': 'Ajouter des fonds',
        'deposit': 'Déposer',
        'withdraw': 'Retirer',
        'withdrawal': 'Retrait',
        'send': 'Envoyer',
        'send money': "Envoyer de l'argent",
        'receive': 'Recevoir',
        'transactions': 'Transactions',
        'transaction history': 'Historique des transactions',
        'history': 'Historique',
        'profile': 'Profil',
        'settings': 'Paramètres',
        'messages': 'Messages',
        'notifications': 'Notifications',
        'referrals': 'Filleuls',
        'help': 'Aide',
        'support': 'Assistance',
        'logout': 'Se déconnecter',
        'log out': 'Se déconnecter',
        'sign out': 'Se déconnecter',
        'login': 'Se connecter',
        'sign in': 'Se connecter',
        'log in': 'Se connecter',
        'sign up': "S'inscrire",
        'register': "S'inscrire",
        'create account': 'Créer un compte',
        'start saving': 'Commencez à épargner',
        'save your money': 'Épargnez votre argent',
        'grow your money': 'Faites fructifier votre argent',
        'earn interest': 'Gagnez des intérêts',
        'withdraw anytime': 'Retirez à tout moment',
        'your savings': 'Vos épargnes',
        'pay': 'Payer',
        'payment': 'Paiement',
        'payments': 'Paiements',
        'pay now': 'Payer maintenant',
        'pay later': 'Payer plus tard',
        'pay in installments': 'Payer en plusieurs fois',
        'buy': 'Acheter',
        'buy now': 'Acheter maintenant',
        'shop': 'Magasiner',
        'products': 'Produits',
        'product': 'Produit',
        'price': 'Prix',
        'add to cart': 'Ajouter au panier',
        'cart': 'Panier',
        'order': 'Commande',
        'orders': 'Commandes',
        'checkout': 'Finaliser la commande',
        'view details': 'Voir les détails',
        'view all': 'Voir tout',
        'see more': 'Voir plus',
        'learn more': 'En savoir plus',
        'read more': 'Lire la suite',
        'show more': 'Afficher plus',
        'next': 'Suivant',
        'previous': 'Précédent',
        'back': 'Retour',
        'continue': 'Continuer',
        'cancel': 'Annuler',
        'close': 'Fermer',
        'done': 'Terminé',
        'ok': 'OK',
        'confirm': 'Confirmer',
        'save changes': 'Enregistrer les modifications',
        'submit': 'Envoyer',
        'search': 'Rechercher',
        'search...': 'Rechercher…',
        'filter': 'Filtrer',
        'sort': 'Trier',
        'name': 'Nom',
        'first name': 'Prénom',
        'last name': 'Nom',
        'email': 'E-mail',
        'email address': 'Adresse e-mail',
        'phone': 'Téléphone',
        'phone number': 'Numéro de téléphone',
        'password': 'Mot de passe',
        'confirm password': 'Confirmez le mot de passe',
        'address': 'Adresse',
        'city': 'Ville',
        'country': 'Pays',
        'date': 'Date',
        'status': 'Statut',
        'type': 'Type',
        'description': 'Description',
        'reference': 'Référence',
        'details': 'Détails',
        'successful': 'Réussi',
        'success': 'Réussi',
        'failed': 'Échec',
        'pending': 'En attente',
        'processing': 'En cours',
        'cancelled': 'Annulé',
        'completed': 'Terminé',
        'active': 'Actif',
        'inactive': 'Inactif',
        'welcome back': 'Bon retour',
        'great to see you': 'Ravi de vous revoir',
        'update': 'Mettre à jour',
        'edit': 'Modifier',
        'delete': 'Supprimer',
        'remove': 'Retirer',
        'add': 'Ajouter',
        'add new': 'Ajouter nouveau',
        'create': 'Créer',
        'mark as read': 'Marquer comme lu',
        'share': 'Partager',
        'copy': 'Copier',
        'copied': 'Copié',
        'download': 'Télécharger',
        'upload': 'Téléverser',
        'no data': 'Aucune donnée',
        'no results': 'Aucun résultat',
        'loading': 'Chargement…',
        'loading...': 'Chargement…',
        'loading…': 'Chargement…',
        'please wait': 'Veuillez patienter',
        'error': 'Erreur',
        'something went wrong': "Une erreur s'est produite",
        'try again': 'Réessayer',
        'retry': 'Réessayer',
        'network error': 'Erreur réseau',
        'today': "Aujourd'hui",
        'yesterday': 'Hier',
        'this week': 'Cette semaine',
        'this month': 'Ce mois-ci',
        'total': 'Total',
        'subtotal': 'Sous-total',
        'tax': 'Taxe',
        'discount': 'Remise',
        'total cost': 'Coût total',
        'confirm payment': 'Confirmer le paiement',
        'payment successful': 'Paiement réussi',
        'payment failed': 'Paiement échoué',
        'group': 'Groupe',
        'groups': 'Groupes',
        'create group': 'Créer un groupe',
        'join group': 'Rejoindre un groupe',
        'members': 'Membres',
        'member': 'Membre',
        'due': 'Échéance',
        'contributions': 'Cotisations',
        'contribute': 'Cotiser',
        'payout': 'Versement',
        'collector': 'Collecteur',
        'validate': 'Valider',
        'validated': 'Validé',
        'not yet paid': 'Pas encore payé',
        'paid': 'Payé',
        'invest': 'Investir',
        'investments': 'Investissements',
        'investment': 'Investissement',
        'returns': 'Rendements',
        'profit': 'Profit',
        'loss': 'Perte',
        'loan': 'Prêt',
        'loans': 'Prêts',
        'apply for loan': 'Demander un prêt',
        'apply': 'Postuler',
        'language': 'Langue',
        'choose language': 'Choisissez la langue',
        'english': 'Anglais',
        'french': 'Français',
        'spanish': 'Espagnol'
      },
      es: {
        'welcome': 'Bienvenido',
        'welcome to': 'Bienvenido a',
        'welcome 😃 to': 'Bienvenido 😃 a',
        ', to pettycash: marketplace': ', a PettyCash: MarketPlace',
        ', to pettycash: savings': ', a PettyCash: Savings',
        ', to pettycash: fundraising': ', a PettyCash: Fundraising',
        ', to pettycash: monitor': ', a PettyCash: Monitor',
        ', to pettycash: njangi': ', a PettyCash: Njangi',
        ', to pettycash business suite': ', a PettyCash Business Suite',
        'to pettycash business suite': 'a PettyCash Business Suite',
        'your credit score:': 'Tu puntaje de credito:',
        'understanding your credit score': 'Entiende tu puntaje de credito',
        'shop at cheap prices/credit at our': 'Compra a buen precio o a credito en nuestro',
        'market place.': 'marketplace.',
        'we make your coins': 'Convertimos tus pequenos ahorros',
        'become a fortune.': 'en una gran fortuna.',
        'we bring life into your': 'Damos vida a tus',
        'dream projects.': 'proyectos sonados.',
        'we guide you to make great': 'Te guiamos para tomar mejores',
        'financial decisions.': 'decisiones financieras.',
        'join communities to': 'Unete a comunidades para',
        'share resources together.': 'compartir recursos.',
        'explore petty ca$h marketplace': 'Descubre Petty Ca$h MarketPlace',
        'explore petty ca$h market place': 'Descubre Petty Ca$h MarketPlace',
        'explore petty ca$h savings': 'Descubre Petty Ca$h Savings',
        'explore petty ca$h fundraising': 'Descubre Petty Ca$h Fundraising',
        'explore petty ca$h monitor': 'Descubre Petty Ca$h Monitor',
        'explore petty ca$h njangi': 'Descubre Petty Ca$h Njangi',
        'explore petty ca$h business account': 'Descubre Petty Ca$h Business Account',
        'referred users': 'Usuarios referidos',
        'username': 'Nombre de usuario',
        'signup date': 'Fecha de registro',
        'payment status': 'Estado del pago',
        'amount': 'Importe',
        'home': 'Inicio',
        'savings': 'Ahorros',
        'fundraising': 'Recaudación de fondos',
        'njangi': 'Tontina',
        'monitor': 'Monitoreo',
        'marketplace': 'MarketPlace',
        'market place': 'MarketPlace',
        'topup': 'Recarga',
        'business suite': 'Business Suite',
        'my savings': 'Mis ahorros',
        'my accounts': 'Mis cuentas',
        'my account': 'Mi cuenta',
        'account': 'Cuenta',
        'accounts': 'Cuentas',
        'balance': 'Saldo',
        'my balance': 'Mi saldo',
        'total balance': 'Saldo total',
        'available balance': 'Saldo disponible',
        'add funds': 'Agregar fondos',
        'deposit': 'Depositar',
        'withdraw': 'Retirar',
        'withdrawal': 'Retiro',
        'send': 'Enviar',
        'send money': 'Enviar dinero',
        'receive': 'Recibir',
        'transactions': 'Transacciones',
        'transaction history': 'Historial de transacciones',
        'history': 'Historial',
        'profile': 'Perfil',
        'settings': 'Configuración',
        'messages': 'Mensajes',
        'notifications': 'Notificaciones',
        'referrals': 'Referidos',
        'help': 'Ayuda',
        'support': 'Soporte',
        'logout': 'Cerrar sesión',
        'log out': 'Cerrar sesión',
        'sign out': 'Cerrar sesión',
        'login': 'Iniciar sesión',
        'sign in': 'Iniciar sesión',
        'log in': 'Iniciar sesión',
        'sign up': 'Registrarse',
        'register': 'Registrarse',
        'create account': 'Crear cuenta',
        'start saving': 'Empieza a ahorrar',
        'save your money': 'Ahorra tu dinero',
        'grow your money': 'Haz crecer tu dinero',
        'earn interest': 'Gana intereses',
        'withdraw anytime': 'Retira cuando quieras',
        'your savings': 'Tus ahorros',
        'pay': 'Pagar',
        'payment': 'Pago',
        'payments': 'Pagos',
        'pay now': 'Pagar ahora',
        'pay later': 'Pagar después',
        'pay in installments': 'Pagar a plazos',
        'buy': 'Comprar',
        'buy now': 'Comprar ahora',
        'shop': 'Comprar',
        'products': 'Productos',
        'product': 'Producto',
        'price': 'Precio',
        'add to cart': 'Añadir al carrito',
        'cart': 'Carrito',
        'order': 'Pedido',
        'orders': 'Pedidos',
        'checkout': 'Finalizar compra',
        'view details': 'Ver detalles',
        'view all': 'Ver todo',
        'see more': 'Ver más',
        'learn more': 'Saber más',
        'read more': 'Leer más',
        'show more': 'Mostrar más',
        'next': 'Siguiente',
        'previous': 'Anterior',
        'back': 'Atrás',
        'continue': 'Continuar',
        'cancel': 'Cancelar',
        'close': 'Cerrar',
        'done': 'Listo',
        'ok': 'Aceptar',
        'confirm': 'Confirmar',
        'save changes': 'Guardar cambios',
        'submit': 'Enviar',
        'search': 'Buscar',
        'search...': 'Buscar…',
        'filter': 'Filtrar',
        'sort': 'Ordenar',
        'name': 'Nombre',
        'first name': 'Nombre',
        'last name': 'Apellido',
        'email': 'Correo',
        'email address': 'Dirección de correo',
        'phone': 'Teléfono',
        'phone number': 'Número de teléfono',
        'password': 'Contraseña',
        'confirm password': 'Confirmar contraseña',
        'address': 'Dirección',
        'city': 'Ciudad',
        'country': 'País',
        'date': 'Fecha',
        'status': 'Estado',
        'type': 'Tipo',
        'description': 'Descripción',
        'reference': 'Referencia',
        'details': 'Detalles',
        'successful': 'Exitoso',
        'success': 'Éxito',
        'failed': 'Fallido',
        'pending': 'Pendiente',
        'processing': 'Procesando',
        'cancelled': 'Cancelado',
        'completed': 'Completado',
        'active': 'Activo',
        'inactive': 'Inactivo',
        'welcome back': 'Bienvenido de nuevo',
        'great to see you': 'Me alegra verte',
        'update': 'Actualizar',
        'edit': 'Editar',
        'delete': 'Eliminar',
        'remove': 'Quitar',
        'add': 'Agregar',
        'add new': 'Agregar nuevo',
        'create': 'Crear',
        'mark as read': 'Marcar como leído',
        'share': 'Compartir',
        'copy': 'Copiar',
        'copied': 'Copiado',
        'download': 'Descargar',
        'upload': 'Subir',
        'no data': 'Sin datos',
        'no results': 'Sin resultados',
        'loading': 'Cargando…',
        'loading...': 'Cargando…',
        'loading…': 'Cargando…',
        'please wait': 'Espere por favor',
        'error': 'Error',
        'something went wrong': 'Algo salió mal',
        'try again': 'Intentar de nuevo',
        'retry': 'Reintentar',
        'network error': 'Error de red',
        'today': 'Hoy',
        'yesterday': 'Ayer',
        'this week': 'Esta semana',
        'this month': 'Este mes',
        'total': 'Total',
        'subtotal': 'Subtotal',
        'tax': 'Impuesto',
        'discount': 'Descuento',
        'total cost': 'Costo total',
        'confirm payment': 'Confirmar pago',
        'payment successful': 'Pago exitoso',
        'payment failed': 'Pago fallido',
        'group': 'Grupo',
        'groups': 'Grupos',
        'create group': 'Crear grupo',
        'join group': 'Unirse al grupo',
        'members': 'Miembros',
        'member': 'Miembro',
        'due': 'Vencimiento',
        'contributions': 'Aportes',
        'contribute': 'Aportar',
        'payout': 'Pago',
        'collector': 'Cobrador',
        'validate': 'Validar',
        'validated': 'Validado',
        'not yet paid': 'Aún no pagado',
        'paid': 'Pagado',
        'invest': 'Invertir',
        'investments': 'Inversiones',
        'investment': 'Inversión',
        'returns': 'Rentabilidad',
        'profit': 'Ganancia',
        'loss': 'Pérdida',
        'loan': 'Préstamo',
        'loans': 'Préstamos',
        'apply for loan': 'Solicitar préstamo',
        'apply': 'Aplicar',
        'language': 'Idioma',
        'choose language': 'Elige idioma',
        'english': 'Inglés',
        'french': 'Francés',
        'spanish': 'Español'
      }
    }

    this.preHideStyleId = 'auto-translate-prehide-style'
    this.preHideReleaseTimer = null

    this.textCache = new Map()
    this.originalTextByNode = new WeakMap()
    this.originalAttrsByElement = new WeakMap()
    this.trackedTextNodes = new Set()
    this.trackedElements = new Set()
    this.observer = null
    this.reapplyTimer = null
    this.isApplying = false
    this.needsCatchUp = false
    this.pendingRoots = new Set()
    this.pendingReapplyReason = ''
    this.inFlightTranslations = new Map()
    this.routeRefreshTimers = []
    this.backendCooldownUntil = 0
    this.googleFailures = 0
    this.googleCooldownUntil = 0
    this.mymemoryFailures = 0
    this.providerDowntimeUntil = 0
    this.boundPersistRuntimeState = null
    this.boundVisibilityChange = null

    this.loadPersistedCache()

    this.refreshProtectedTerms()
    this.setupLifecyclePersistence()
  }

  getWindowPath() {
    if (typeof window === 'undefined' || !window.location) {
      return ''
    }
    return (window.location.pathname || '') + (window.location.search || '')
  }

  normalizeLang(lang) {
    return this.supportedLanguages.includes(lang) ? lang : this.defaultLanguage
  }

  getSupportedLanguages() {
    return this.supportedLanguages.slice()
  }

  loadPersistedCache() {
    try {
      const raw = localStorage.getItem(this.cacheStorageKey)
      if (!raw) {
        return
      }

      const entries = JSON.parse(raw)
      if (!Array.isArray(entries)) {
        return
      }

      const recent = entries.slice(-this.maxCacheEntries)
      for (let i = 0; i < recent.length; i += 1) {
        const pair = recent[i]
        if (!Array.isArray(pair) || pair.length !== 2) {
          continue
        }
        const key = typeof pair[0] === 'string' ? pair[0] : ''
        const value = typeof pair[1] === 'string' ? pair[1] : ''
        if (!key) {
          continue
        }
        const separatorIndex = key.indexOf('|')
        if (separatorIndex > 0 && value === key.slice(separatorIndex + 1)) {
          continue
        }
        this.textCache.set(key, value)
      }
    } catch (error) {
      // Ignore corrupted local cache
    }
  }

  persistCacheSoon() {
    clearTimeout(this.cachePersistTimer)
    this.cachePersistTimer = setTimeout(() => {
      this.persistCache()
    }, this.cachePersistDelayMs)
  }

  persistCache() {
    clearTimeout(this.cachePersistTimer)
    this.cachePersistTimer = null
    try {
      const entries = Array.from(this.textCache.entries()).slice(-this.maxCacheEntries)
      localStorage.setItem(this.cacheStorageKey, JSON.stringify(entries))
    } catch (error) {
      // Ignore storage quota / access errors
    }
  }

  persistRuntimeState() {
    try {
      localStorage.setItem(this.storageKey, this.currentLang)
    } catch (error) {
      // Ignore storage access errors
    }

    this.persistCache()
  }

  setupLifecyclePersistence() {
    if (typeof window === 'undefined' || this.boundPersistRuntimeState) {
      return
    }

    this.boundPersistRuntimeState = () => {
      this.persistRuntimeState()
    }

    this.boundVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        this.persistRuntimeState()
      }
    }

    window.addEventListener('pagehide', this.boundPersistRuntimeState, { capture: true })
    window.addEventListener('beforeunload', this.boundPersistRuntimeState, { capture: true })
    document.addEventListener('visibilitychange', this.boundVisibilityChange, { capture: true })
  }

  setProtectedTerms(terms) {
    this.dynamicProtectedTerms = new Set(
      (terms || [])
        .map(term => (term || '').toString().trim())
        .filter(Boolean)
    )
    this.refreshProtectedTerms()
  }

  refreshProtectedTerms() {
    const merged = new Set()

    for (let i = 0; i < this.baseProtectedTerms.length; i += 1) {
      const term = (this.baseProtectedTerms[i] || '').trim()
      if (term) {
        merged.add(term)
      }
    }

    this.dynamicProtectedTerms.forEach(term => {
      const value = (term || '').toString().trim()
      if (value) {
        merged.add(value)
      }
    })

    if (typeof window !== 'undefined' && window.__PETTYCASH_USERNAME) {
      const runtimeUser = String(window.__PETTYCASH_USERNAME).trim()
      if (runtimeUser) {
        merged.add(runtimeUser)
      }
    }

    const nextHash = Array.from(merged).sort().join('\u0000')
    if (nextHash !== this.protectedTermsHash) {
      this.protectedTermsHash = nextHash
    }

    this.protectedTerms = merged
  }

  getLanguage() {
    return this.currentLang
  }

  isTranslatedEnabled() {
    return this.currentLang !== this.defaultLanguage
  }

  // Backward compatibility with old API
  isEnglishEnabled() {
    return this.currentLang === this.defaultLanguage
  }

  setCurrentPath(path) {
    this.currentPath = (path || '').toLowerCase()
  }

  isPathExcluded(path) {
    const normalized = (path || this.currentPath || '').toLowerCase()
    for (let i = 0; i < this.excludedPathSubstrings.length; i += 1) {
      if (normalized.includes(this.excludedPathSubstrings[i])) {
        return true
      }
    }
    return false
  }

  prepareInitialPaint() {
    if (this.currentLang === this.defaultLanguage || this.isPathExcluded()) {
      return
    }

    if (document.getElementById(this.preHideStyleId)) {
      return
    }

    const style = document.createElement('style')
    style.id = this.preHideStyleId
    style.textContent = 'body{opacity:0!important}'
    document.head.appendChild(style)

    clearTimeout(this.preHideReleaseTimer)
    this.preHideReleaseTimer = setTimeout(() => {
      this.releaseInitialPaint()
    }, 1600)
  }

  releaseInitialPaint() {
    clearTimeout(this.preHideReleaseTimer)
    const style = document.getElementById(this.preHideStyleId)
    if (style && style.parentNode) {
      style.parentNode.removeChild(style)
    }
  }

  async init() {
    this.setCurrentPath(this.getWindowPath())
    this.cleanupGoogleArtifacts()
    this.refreshProtectedTerms()

    try {
      if (this.currentLang !== this.defaultLanguage && !this.isPathExcluded()) {
        await this.applyTranslation()
        this.startObserver()
      } else {
        this.stopObserver()
        this.restoreOriginalContent()
      }
    } finally {
      this.persistRuntimeState()
      this.releaseInitialPaint()
    }
  }

  async setLanguage(lang) {
    const nextLang = this.normalizeLang(lang)
    if (nextLang === this.currentLang) {
      return { applied: this.currentLang !== this.defaultLanguage, excluded: this.isPathExcluded() }
    }

    this.currentLang = nextLang
    try {
      localStorage.setItem(this.storageKey, this.currentLang)
    } catch (error) {
      // Ignore storage access errors
    }
    this.cleanupGoogleArtifacts()
    this.refreshProtectedTerms()

    if (this.currentLang === this.defaultLanguage) {
      this.stopObserver()
      this.restoreOriginalContent()
      this.persistRuntimeState()
      this.releaseInitialPaint()
      return { applied: true, excluded: false }
    }

    if (this.isPathExcluded()) {
      this.stopObserver()
      this.restoreOriginalContent()
      this.persistRuntimeState()
      this.releaseInitialPaint()
      return { applied: false, excluded: true }
    }

    this.prepareInitialPaint()
    try {
      await this.applyTranslation()
      this.startObserver()
      this.persistRuntimeState()
      return { applied: true, excluded: false }
    } finally {
      this.releaseInitialPaint()
    }
  }

  // Backward compatibility with old API
  async toggle() {
    if (this.currentLang === this.defaultLanguage) {
      return this.setLanguage('fr')
    }
    return this.setLanguage(this.defaultLanguage)
  }

  // Backward compatibility with old API
  async enableEnglish() {
    return this.setLanguage('en')
  }

  // Backward compatibility with old API
  async disableTranslation() {
    return this.setLanguage('en')
  }

  refreshIfEnabled(reason, root) {
    if (this.currentLang === this.defaultLanguage || this.isPathExcluded()) {
      return
    }

    if (reason === 'route') {
      this.scheduleRouteRefreshSequence()
      return
    }

    if (root && root.nodeType) {
      this.pendingRoots.add(root.nodeType === Node.TEXT_NODE ? root.parentNode : root)
    }
    this.pendingReapplyReason = reason || this.pendingReapplyReason || 'dom'

    const waitMs = reason === 'route' ? 80 : 180
    this.scheduleReapply(waitMs)
  }

  clearRouteRefreshTimers() {
    for (let i = 0; i < this.routeRefreshTimers.length; i += 1) {
      clearTimeout(this.routeRefreshTimers[i])
    }
    this.routeRefreshTimers = []
  }

  scheduleRouteRefreshSequence() {
    this.clearRouteRefreshTimers()

    // Multi-pass refresh to keep translations on async/lazy-rendered route content.
    // The late passes (1.8s / 4s) catch content revealed after slow async loads (mobile).
    const delays = [60, 300, 900, 1800, 4000]
    for (let i = 0; i < delays.length; i += 1) {
      const timer = setTimeout(() => {
        this.applyTranslation().catch(() => {})
      }, delays[i])
      this.routeRefreshTimers.push(timer)
    }
  }

  scheduleReapply(waitMs) {
    clearTimeout(this.reapplyTimer)
    this.reapplyTimer = setTimeout(async () => {
      const reason = this.pendingReapplyReason || 'dom'
      this.pendingReapplyReason = ''

      const roots = this.getOptimizedPendingRoots()
      if (reason === 'route' || roots.length === 0) {
        await this.applyTranslation().catch(() => {})
        return
      }

      for (let i = 0; i < roots.length; i += 1) {
        await this.applyTranslation(roots[i]).catch(() => {})
      }

      if (this.pendingRoots.size > 0) {
        this.scheduleReapply(160)
      }
    }, waitMs)
  }

  getOptimizedPendingRoots() {
    const roots = []
    this.pendingRoots.forEach(root => {
      if (root && root.isConnected) {
        roots.push(root)
      }
    })
    this.pendingRoots.clear()

    if (roots.length <= 1) {
      return roots
    }

    const optimized = []
    for (let i = 0; i < roots.length; i += 1) {
      const root = roots[i]
      if (!root || !root.isConnected) {
        continue
      }
      if (root === document.body || root === document.documentElement) {
        return [document.body]
      }

      let contained = false
      for (let j = 0; j < roots.length; j += 1) {
        if (i === j) {
          continue
        }
        const other = roots[j]
        if (!other || !other.isConnected) {
          continue
        }
        if (other.contains && other.contains(root)) {
          contained = true
          break
        }
      }

      if (!contained) {
        optimized.push(root)
      }
    }

    const MAX_ROOTS_PER_PASS = 12
    if (optimized.length > MAX_ROOTS_PER_PASS) {
      for (let i = MAX_ROOTS_PER_PASS; i < optimized.length; i += 1) {
        this.pendingRoots.add(optimized[i])
      }
      return optimized.slice(0, MAX_ROOTS_PER_PASS)
    }

    return optimized
  }

  shouldIgnoreMutation(mutation) {
    const target = mutation && mutation.target
    if (!target) {
      return true
    }

    const element = target.nodeType === Node.ELEMENT_NODE ? target : target.parentElement
    if (!element) {
      return true
    }

    if (element.closest('[translate="no"], .notranslate, .browser-translate-toggle, .v-icon, .material-icons, .material-symbols-outlined, .fa, .fas, .far, .fal, .fab, .mdi')) {
      return true
    }

    return false
  }

  startObserver() {
    if (this.observer || !document.body) {
      return
    }

    this.observer = new MutationObserver(mutations => {
      if (this.isApplying) {
        this.needsCatchUp = true
        return
      }

      for (let i = 0; i < mutations.length; i += 1) {
        const mutation = mutations[i]
        if (this.shouldIgnoreMutation(mutation)) {
          continue
        }
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          this.refreshIfEnabled('dom', mutation.target)
          return
        }
      }
    })

    this.observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    })
  }

  stopObserver() {
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
    clearTimeout(this.reapplyTimer)
    this.pendingRoots.clear()
    this.pendingReapplyReason = ''
    this.clearRouteRefreshTimers()
  }

  async applyTranslation(root) {
    if (this.currentLang === this.defaultLanguage || this.isPathExcluded()) {
      return
    }

    const scope = root && root.nodeType ? root : document.body
    if (!scope) {
      return
    }

    this.isApplying = true

    try {
      await Promise.all([
        this.translateTextNodes(scope, this.currentLang),
        this.translateElementAttributes(scope, this.currentLang)
      ])
    } finally {
      this.isApplying = false
      if (this.needsCatchUp) {
        this.needsCatchUp = false
        this.refreshIfEnabled('dom')
      }
    }
  }

  async translateTextNodes(root, lang) {
    const nodes = this.collectTranslatableTextNodes(root)
    const nodePayload = []
    const uniqueTexts = new Set()

    for (let i = 0; i < nodes.length; i += 1) {
      const node = nodes[i]
      if (!this.originalTextByNode.has(node)) {
        this.originalTextByNode.set(node, node.textContent)
        this.trackedTextNodes.add(node)
      }

      const original = this.originalTextByNode.get(node) || ''
      const parts = this.splitWhitespace(original)
      if (!parts.core) {
        continue
      }

      nodePayload.push({ node, parts })
      uniqueTexts.add(parts.core)
    }

    const translations = await this.translateMany(Array.from(uniqueTexts), lang)

    for (let i = 0; i < nodePayload.length; i += 1) {
      const item = nodePayload[i]
      const translated = translations.get(item.parts.core) || item.parts.core
      const nextValue = item.parts.leading + translated + item.parts.trailing
      if (item.node.textContent !== nextValue) {
        item.node.textContent = nextValue
      }
    }
  }

  async translateElementAttributes(root, lang) {
    const attrs = ['placeholder', 'title', 'aria-label', 'alt', 'data-original-title']
    const elements = root.querySelectorAll ? root.querySelectorAll('*') : []
    const attrPayload = []
    const uniqueTexts = new Set()

    for (let i = 0; i < elements.length; i += 1) {
      const element = elements[i]
      if (!this.isElementTranslatable(element)) {
        continue
      }

      let originalAttrs = this.originalAttrsByElement.get(element)
      if (!originalAttrs) {
        originalAttrs = {}
        this.originalAttrsByElement.set(element, originalAttrs)
        this.trackedElements.add(element)
      }

      for (let j = 0; j < attrs.length; j += 1) {
        const attr = attrs[j]
        const currentValue = element.getAttribute(attr)
        if (!currentValue) {
          continue
        }

        if (!Object.prototype.hasOwnProperty.call(originalAttrs, attr)) {
          originalAttrs[attr] = currentValue
        }

        const originalValue = originalAttrs[attr]
        const parts = this.splitWhitespace(originalValue)
        if (!parts.core) {
          continue
        }

        attrPayload.push({ element, attr, parts })
        uniqueTexts.add(parts.core)
      }
    }

    const translations = await this.translateMany(Array.from(uniqueTexts), lang)

    for (let i = 0; i < attrPayload.length; i += 1) {
      const item = attrPayload[i]
      const translated = translations.get(item.parts.core) || item.parts.core
      const nextValue = item.parts.leading + translated + item.parts.trailing
      if (item.element.getAttribute(item.attr) !== nextValue) {
        item.element.setAttribute(item.attr, nextValue)
      }
    }
  }

  restoreOriginalContent() {
    this.trackedTextNodes.forEach(node => {
      if (!node || !node.isConnected) {
        return
      }

      const original = this.originalTextByNode.get(node)
      if (typeof original === 'string' && node.textContent !== original) {
        node.textContent = original
      }
    })

    this.trackedElements.forEach(element => {
      if (!element || !element.isConnected) {
        return
      }

      const originalAttrs = this.originalAttrsByElement.get(element)
      if (!originalAttrs) {
        return
      }

      Object.keys(originalAttrs).forEach(attr => {
        element.setAttribute(attr, originalAttrs[attr])
      })
    })
  }

  collectTranslatableTextNodes(root) {
    const nodes = []
    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: node => {
          if (!node || !node.parentElement) {
            return NodeFilter.FILTER_REJECT
          }

          if (!this.isElementTranslatable(node.parentElement)) {
            return NodeFilter.FILTER_REJECT
          }

          const value = node.textContent || ''
          if (!this.hasMeaningfulText(value)) {
            return NodeFilter.FILTER_REJECT
          }

          return NodeFilter.FILTER_ACCEPT
        }
      }
    )

    let current = walker.nextNode()
    while (current) {
      nodes.push(current)
      current = walker.nextNode()
    }

    return nodes
  }

  hasMeaningfulText(value) {
    const text = (value || '').trim()
    if (!text) {
      return false
    }

    if (text.length < 2) {
      return false
    }

    if (/^[\d\s.,:/+-]+$/.test(text)) {
      return false
    }

    return true
  }

  hasIconClass(element) {
    const classList = element.classList || []
    for (let i = 0; i < classList.length; i += 1) {
      const cls = classList[i]
      if (cls === 'v-icon' || cls === 'material-icons' || cls === 'material-icons-outlined' || cls === 'material-symbols-outlined') {
        return true
      }
      if (cls === 'fa' || cls.startsWith('fa-') || cls === 'fas' || cls === 'far' || cls === 'fal' || cls === 'fab') {
        return true
      }
      if (cls === 'mdi' || cls.startsWith('mdi-')) {
        return true
      }
    }
    return false
  }

  isElementTranslatable(element) {
    if (!element || !element.tagName) {
      return false
    }

    const tag = element.tagName.toLowerCase()
    if (tag === 'script' || tag === 'style' || tag === 'noscript' || tag === 'code' || tag === 'pre' || tag === 'svg' || tag === 'path' || tag === 'use') {
      return false
    }

    if (this.hasIconClass(element)) {
      return false
    }

    if (element.getAttribute('role') === 'img') {
      return false
    }

    const className = (element.className || '').toString().toLowerCase()
    if (className.includes('username') || className.includes('user-name') || className.includes('member-name')) {
      return false
    }

    if (element.closest('[translate="no"], .notranslate, .browser-translate-toggle, .v-icon, .material-icons, .material-symbols-outlined, .fa, .fas, .far, .fal, .fab, .mdi')) {
      return false
    }

    if (this.isSplitBrandFragment(element)) {
      return false
    }

    return true
  }

  isSplitBrandFragment(element) {
    // Handles logos rendered as separate elements (e.g. <span>Petty</span><span>Cash</span><span> SAS</span>).
    // Each fragment alone is a real word ("petty", "cash", "sas") so the brand regex cannot match it;
    // translate them individually and Google mangles the brand (PettyCash -> PetiteTrésorerie...).
    const own = (element && element.textContent ? element.textContent : '').trim()
    if (!own || !/^(petty|cash|sas|ca\$h|pettycash|petty\s*c[a$]h|petty\s*cash)$/i.test(own)) {
      return false
    }

    const ancestor = element.parentElement
    if (!ancestor) {
      return false
    }

    return this.isBrandOnlyCollapsed(ancestor.textContent || '')
  }

  isBrandOnlyCollapsed(text) {
    const value = (text || '').replace(/\s+/g, ' ').trim()
    if (!value || value.length > 60 || /\d/.test(value)) {
      return false
    }
    // Allow a short prefix (icons like "account_balance", a small lead-in, even glued word chars),
    // then the full brand, then optionally "SAS" and trailing punctuation only.
    return /^.{0,24}?petty[-\s_]*c[-\s_]*a[-\s_]*[$s]?[-\s_]*h\b(?!\w)(?:\s*?\.?\s*?sas)?[.\s]*$/i.test(value)
  }

  splitWhitespace(text) {
    const value = text || ''
    const match = value.match(/^(\s*)([\s\S]*?)(\s*)$/)
    if (!match) {
      return { leading: '', core: value, trailing: '' }
    }
    return {
      leading: match[1] || '',
      core: (match[2] || '').trim() ? match[2] : '',
      trailing: match[3] || ''
    }
  }

  normalizeLookupText(text) {
    return (text || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase()
  }

  getContextAwareTranslation(text, lang) {
    const langKey = this.normalizeLang(lang || this.currentLang)
    const overrides = this.contextTranslations[langKey]
    if (!overrides) {
      return ''
    }

    const lookupKey = this.normalizeLookupText(text)
    if (!lookupKey) {
      return ''
    }

    if (Object.prototype.hasOwnProperty.call(overrides, lookupKey)) {
      return overrides[lookupKey]
    }

    return ''
  }

  async translate(text, targetLang) {
    const translations = await this.translateMany([text], targetLang)
    return translations.get(text) || text
  }

  async translateMany(texts, targetLang) {
    const lang = this.normalizeLang(targetLang || this.currentLang)
    const results = new Map()
    const pendingInFlight = []

    if (lang === this.defaultLanguage) {
      for (let i = 0; i < texts.length; i += 1) {
        results.set(texts[i], texts[i])
      }
      return results
    }

    const uniqueTexts = []
    const seen = new Set()
    for (let i = 0; i < texts.length; i += 1) {
      const text = texts[i]
      if (!text || seen.has(text)) {
        continue
      }
      seen.add(text)
      uniqueTexts.push(text)
    }

    const directContextCount = this.applyContextTranslations(uniqueTexts, lang, results)

    const toResolve = []
    for (let i = 0; i < uniqueTexts.length; i += 1) {
      const text = uniqueTexts[i]
      const cacheKey = lang + '|' + text
      if (results.has(text)) {
        continue
      } else if (this.textCache.has(cacheKey)) {
        results.set(text, this.textCache.get(cacheKey))
      } else if (this.inFlightTranslations.has(cacheKey)) {
        pendingInFlight.push({
          text,
          promise: this.inFlightTranslations.get(cacheKey)
        })
      } else {
        toResolve.push(text)
      }
    }

    if (pendingInFlight.length > 0) {
      await Promise.all(
        pendingInFlight.map(async item => {
          const translated = await item.promise.catch(() => item.text)
          results.set(item.text, translated || item.text)
        })
      )
    }

    const toFetch = toResolve.filter(text => !results.has(text))
    const batches = this.buildTextBatches(toFetch, 1250)

    await this.runWithConcurrency(batches, 6, async batch => {
      if (!batch || batch.length === 0) {
        return
      }

      const batchTask = this.translateBatchViaApi(batch, lang)

      for (let i = 0; i < batch.length; i += 1) {
        const text = batch[i]
        const cacheKey = lang + '|' + text
        if (!this.inFlightTranslations.has(cacheKey)) {
          const textPromise = batchTask
            .then(translatedBatch => translatedBatch[i] || text)
            .catch(() => text)
            .finally(() => {
              this.inFlightTranslations.delete(cacheKey)
            })

          this.inFlightTranslations.set(cacheKey, textPromise)
        }
      }

      const translatedBatch = await batchTask.catch(() => batch)
      for (let i = 0; i < batch.length; i += 1) {
        const text = batch[i]
        const translated = translatedBatch[i] || text
        const cacheKey = lang + '|' + text
        if (translated !== text) {
          this.textCache.set(cacheKey, translated)
        }
        results.set(text, translated)
      }
    })

    if (toFetch.length > 0 || directContextCount > 0) {
      this.persistCacheSoon()
    }

    // Brand integrity guard — the PettyCash family must never be translated,
    // no matter the source, the language or the provider.
    for (let i = 0; i < uniqueTexts.length; i += 1) {
      const text = uniqueTexts[i]
      const translated = results.get(text)
      if (typeof translated !== 'string') {
        continue
      }
      const repaired = this.repairBrandIntegrity(text, translated)
      if (repaired !== translated) {
        results.set(text, repaired)
      }
    }

    for (let i = 0; i < uniqueTexts.length; i += 1) {
      const text = uniqueTexts[i]
      if (!results.has(text)) {
        results.set(text, text)
      }
    }

    return results
  }

  applyContextTranslations(texts, lang, results) {
    let count = 0
    for (let i = 0; i < texts.length; i += 1) {
      const text = texts[i]
      const contextTranslation = this.getContextAwareTranslation(text, lang)
      if (!contextTranslation) {
        continue
      }

      const cacheKey = lang + '|' + text
      this.textCache.set(cacheKey, contextTranslation)
      results.set(text, contextTranslation)
      count += 1
    }
    return count
  }

  buildTextBatches(texts, maxChars) {
    if (!texts || texts.length === 0) {
      return []
    }

    const limit = Math.max(200, maxChars || 1250)
    const batches = []
    let current = []
    let currentSize = 0
    const separatorSize = 22

    for (let i = 0; i < texts.length; i += 1) {
      const text = texts[i]
      const size = text.length + (current.length > 0 ? separatorSize : 0)

      if (current.length > 0 && currentSize + size > limit) {
        batches.push(current)
        current = [text]
        currentSize = text.length
      } else {
        current.push(text)
        currentSize += size
      }
    }

    if (current.length > 0) {
      batches.push(current)
    }

    return batches
  }

  getBatchDelimiter(texts) {
    let delimiter = ' __PCT_BATCH_SPLIT__ '
    const source = texts || []

    while (source.some(text => (text || '').indexOf(delimiter) !== -1)) {
      delimiter += '_X'
    }

    return delimiter
  }

  fetchWithTimeout(url, options, timeoutMs) {
    const ms = timeoutMs || 8000
    let controller = null
    if (typeof AbortController !== 'undefined') {
      controller = new AbortController()
    }
    const timer = controller ? setTimeout(() => controller.abort(), ms) : null
    const requestOptions = Object.assign({}, options)
    if (controller) {
      requestOptions.signal = controller.signal
    }
    return fetch(url, requestOptions).then(
      response => {
        if (timer) {
          clearTimeout(timer)
        }
        return response
      },
      error => {
        if (timer) {
          clearTimeout(timer)
        }
        throw error
      }
    )
  }

  markGoogleFailure() {
    this.googleFailures += 1
    if (this.googleFailures >= 2) {
      this.googleCooldownUntil = Date.now() + 60000
      this.providerDowntimeUntil = Date.now() + 120000
    }
  }

  async translateBatchViaApi(texts, lang) {
    if (!texts || texts.length === 0) {
      return []
    }

    if (Date.now() < this.providerDowntimeUntil) {
      // All translation providers recently failed: serve cached <-> identity instantly.
      return texts.slice()
    }

    const now = Date.now()
    if (now < this.backendCooldownUntil) {
      // Backend recently failed: skip it for this pass to avoid repeated stalls.
    } else {
      try {
        const backend = await this.translateViaBackend(texts, lang)
        if (backend) {
          return backend
        }
      } catch (error) {
        // Backend unavailable or errored: fall through to direct providers.
      }
    }

    if (texts.length === 1) {
      return [await this.translateViaApi(texts[0], lang)]
    }

    try {
      const delimiter = this.getBatchDelimiter(texts)
      const mergedText = texts.join(delimiter)

      const protectedPayload = this.protectTermsInText(mergedText)
      const url = 'https://translate.googleapis.com/translate_a/single?client=gtx&sl=auto&tl=' +
        encodeURIComponent(lang) +
        '&dt=t&q=' +
        encodeURIComponent(protectedPayload.value)

      if (Date.now() < this.googleCooldownUntil) {
        throw new Error('google-cooldown')
      }
      const response = await this.fetchWithTimeout(url, null, 8000)
      if (!response.ok) {
        this.markGoogleFailure()
        throw new Error('google-http-' + response.status)
      }
      const data = await response.json()
      if (!Array.isArray(data) || !Array.isArray(data[0])) {
        this.markGoogleFailure()
        throw new Error('google-bad-response')
      }
      this.googleFailures = 0

      const rawTranslated = data[0].map(item => item[0]).join('') || mergedText
      const restored = this.restoreProtectedTerms(rawTranslated, protectedPayload.placeholders)
      const parts = restored.split(delimiter)
      if (parts.length !== texts.length) {
        this.markGoogleFailure()
        throw new Error('google-batch-mismatch')
      }

      return parts
    } catch (error) {
      return this.translateBatchFallback(texts, lang)
    }
  }

  async translateBatchFallback(texts, lang) {
    const output = new Array(texts.length)
    await this.runWithConcurrency(texts.map((text, index) => ({ text, index })), 8, async item => {
      const translated = await this.translateViaMyMemory(item.text, lang).catch(() => item.text)
      output[item.index] = translated || item.text
    })
    return output
  }

  async runWithConcurrency(items, limit, worker) {
    if (!items || items.length === 0) {
      return
    }

    let index = 0
    const runner = async () => {
      while (index < items.length) {
        const currentIndex = index
        index += 1
        await worker(items[currentIndex])
      }
    }

    const count = Math.min(limit, items.length)
    const tasks = []
    for (let i = 0; i < count; i += 1) {
      tasks.push(runner())
    }

    await Promise.all(tasks)
  }

  async translateViaBackend(texts, lang) {
    const apiBase = String(process.env.VUE_APP_API_URL || '').replace(/\/+$/, '')
    if (!apiBase) {
      return null
    }

    let response
    try {
      response = await this.fetchWithTimeout(apiBase + '/api/v1/translate/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ target_lang: lang, texts }),
        credentials: 'omit'
      }, 6000)
    } catch (error) {
      this.backendCooldownUntil = Date.now() + 30000
      throw error
    }
    if (!response.ok) {
      this.backendCooldownUntil = Date.now() + 30000
      return null
    }

    const data = await response.json()
    const mapping = data && data.translations
    if (!mapping || typeof mapping !== 'object') {
      this.backendCooldownUntil = Date.now() + 30000
      return null
    }

    const results = []
    for (let i = 0; i < texts.length; i += 1) {
      if (!Object.prototype.hasOwnProperty.call(mapping, texts[i])) {
        this.backendCooldownUntil = Date.now() + 30000
        return null
      }
      results.push(mapping[texts[i]])
    }
    return results.length === texts.length ? results : null
  }

  async translateViaApi(text, lang) {
    if (!text || typeof text !== 'string') {
      return text
    }

    try {
      const contextTranslation = this.getContextAwareTranslation(text, lang)
      if (contextTranslation) {
        return contextTranslation
      }

      const protectedPayload = this.protectTermsInText(text)
      const url = 'https://translate.googleapis.com/translate_a/single?client=gtx&sl=auto&tl=' +
        encodeURIComponent(lang) +
        '&dt=t&q=' +
        encodeURIComponent(protectedPayload.value)

      if (Date.now() < this.googleCooldownUntil) {
        throw new Error('google-cooldown')
      }
      const response = await this.fetchWithTimeout(url, null, 8000)
      if (!response.ok) {
        this.markGoogleFailure()
        throw new Error('google-http-' + response.status)
      }
      const data = await response.json()
      if (!Array.isArray(data) || !Array.isArray(data[0])) {
        this.markGoogleFailure()
        throw new Error('google-bad-response')
      }
      this.googleFailures = 0

      const rawTranslated = data[0].map(item => item[0]).join('') || text
      return this.repairBrandIntegrity(text, this.restoreProtectedTerms(rawTranslated, protectedPayload.placeholders))
    } catch (error) {
      try {
        const fallback = await this.translateViaMyMemory(text, lang)
        return this.repairBrandIntegrity(text, fallback || text)
      } catch (fallbackError) {
        return text
      }
    }
  }

  async translateViaMyMemory(text, lang) {
    if (!text || typeof text !== 'string') {
      return ''
    }

    try {
      const protectedPayload = this.protectTermsInText(text)
      const url = 'https://api.mymemory.translated.net/get?q=' +
        encodeURIComponent(protectedPayload.value) +
        '&langpair=' +
        encodeURIComponent('en|' + lang) +
        '&mt=1'

      const response = await this.fetchWithTimeout(url, null, 8000)
      if (!response.ok) {
        throw new Error('mymemory-http-' + response.status)
      }

      const data = await response.json()
      const translated = data && data.responseData && data.responseData.translatedText
      const status = data && data.responseStatus
      if (!translated || String(status) !== '200') {
        throw new Error('mymemory-status-' + status)
      }

      this.mymemoryFailures = 0
      return this.repairBrandIntegrity(text, this.restoreProtectedTerms(String(translated), protectedPayload.placeholders))
    } catch (error) {
      this.mymemoryFailures += 1
      if (this.mymemoryFailures >= 3) {
        this.providerDowntimeUntil = Date.now() + 120000
      }
      throw error
    }
  }

  protectTermsInText(text) {
    this.refreshProtectedTerms()

    const placeholders = []
    let value = text
    const terms = Array.from(this.protectedTerms).sort((a, b) => b.length - a.length)

    for (let i = 0; i < terms.length; i += 1) {
      const term = terms[i]
      if (!term) {
        continue
      }

      const escaped = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      const pattern = new RegExp(escaped, 'ig')
      const tokenBase = '__PCTERM_' + i + '_'

      let occurrence = 0
      value = value.replace(pattern, match => {
        const token = tokenBase + occurrence + '__'
        occurrence += 1
        placeholders.push({ token, term: match })
        return token
      })
    }

    // Catch-all: any spelling/casing of the PettyCash brand family must stay verbatim.
    value = this.protectBrandTerms(value, placeholders)

    return { value, placeholders }
  }

  restoreProtectedTerms(text, placeholders) {
    let value = text
    const pairs = placeholders || []

    for (let i = 0; i < pairs.length; i += 1) {
      const pair = pairs[i]
      if (!pair || !pair.token) {
        continue
      }
      value = value.split(pair.token).join(pair.term)
    }

    return value
  }

  brandTermPattern() {
    // Matches every form of the PettyCash family: pettycash, PettyCash, petty cash,
    // Petty Ca$h, petty-cash, PETTYCASH, etc.
    return /\bpetty[-\s_]*c[-\s_]*a[-\s_]*[$s]?[-\s_]*h\b/gi
  }

  brandScope(text) {
    return (text || '').match(this.brandTermPattern()) || []
  }

  hasBrandInText(text) {
    return this.brandScope(text).length > 0
  }

  protectBrandTerms(value, placeholders) {
    const tokenBase = '__PCTBRAND_'
    let occurrence = 0
    return value.replace(this.brandTermPattern(), match => {
      const token = tokenBase + occurrence + '__'
      occurrence += 1
      placeholders.push({ token, term: match })
      return token
    })
  }

  repairBrandIntegrity(source, translated) {
    const srcBrand = this.brandScope(source)[0]
    if (!srcBrand) {
      return translated
    }

    if (this.brandScope(translated).length > 0) {
      return translated
    }

    // The provider may have mangled or dropped the placeholder token(s).
    // Restore any visible leftover token, then fall back to the untouched source
    // only as the very last resort (never show a corrupted brand name).
    const cleaned = String(translated || '').replace(/__PCT[A-Z_]*_\d+(?:_\d+)?__/g, srcBrand)
    if (this.brandScope(cleaned).length > 0) {
      return cleaned
    }

    return source
  }

  cleanupGoogleArtifacts() {
    const selectors = [
      '#google_translate_element',
      '.goog-te-banner-frame',
      'iframe.goog-te-banner-frame',
      '.goog-te-balloon-frame',
      'iframe.goog-te-balloon-frame',
      '.goog-te-menu-frame',
      'iframe.goog-te-menu-frame',
      '#goog-gt-tt',
      '.goog-tooltip'
    ]

    for (let i = 0; i < selectors.length; i += 1) {
      const nodes = document.querySelectorAll(selectors[i])
      for (let j = 0; j < nodes.length; j += 1) {
        const node = nodes[j]
        node.style.display = 'none'
        if (node.id === 'google_translate_element') {
          continue
        }
        if (node.parentNode && node !== document.body && node !== document.documentElement) {
          node.parentNode.removeChild(node)
        }
      }
    }

    const skipNodes = document.querySelectorAll('.skiptranslate')
    for (let i = 0; i < skipNodes.length; i += 1) {
      skipNodes[i].classList.remove('skiptranslate')
    }

    if (document.body) {
      document.body.style.top = '0px'
      document.body.classList.remove('translated-ltr', 'translated-rtl')
    }

    if (document.documentElement) {
      document.documentElement.classList.remove('translated-ltr', 'translated-rtl')
    }
  }
}

export default new AutoTranslator()
